import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const AdminRouteDesignate = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    endPoint: '',
    retreatDay: '',
    direction1: '',
    direction2: '',
    wineryHours: '',
    warehouseSchedule2: '',
    warehousePickupSchedule: '',
    warehousePickupSchedule2: '',
    arrivalAtDestinationDeliveryDay: '',
    assignedTo: '',
    amount: '',
    vat: '1.19'
  });
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [destinations, setDestinations] = useState([]);
  const [loadingDestinations, setLoadingDestinations] = useState(true);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchUsers();
    fetchDestinations();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoadingUsers(true);
      const res = await axios.get('/api/admin/users');
      // Filter only users (transportation companies), not admins
      const transportUsers = res.data.filter(user => user.role === 'user');
      setUsers(transportUsers);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoadingUsers(false);
    }
  };

  const fetchDestinations = async () => {
    try {
      setLoadingDestinations(true);
      const res = await axios.get('/api/admin/destinations');
      setDestinations(res.data);
    } catch (error) {
      console.error('Error fetching destinations:', error);
    } finally {
      setLoadingDestinations(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('/api/admin/routes/designate', {
        ...formData,
        assignedTo: formData.assignedTo || undefined
      });
      
      if (response.data && response.data.route) {
        // Route created successfully
        navigate('/admin/routes', { state: { refresh: true, message: '¡Ruta creada exitosamente!' } });
      } else {
        setError('Ruta creada pero no se devolvieron datos');
      }
    } catch (err) {
      console.error('Error creating route:', err);
      setError(err.response?.data?.message || err.response?.data?.errors?.[0]?.msg || 'Error al designar la ruta');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>Designar Nueva Ruta</h2>
      <div className="card">
        {error && <div className="alert alert-error">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Destino *</label>
            <select
              name="endPoint"
              value={formData.endPoint}
              onChange={handleChange}
              required
              style={{ 
                width: '100%', 
                padding: '12px 16px', 
                border: '2px solid #e5e7eb', 
                borderRadius: '8px',
                fontSize: '14px',
                transition: 'all 0.2s',
                outline: 'none',
                backgroundColor: 'white'
              }}
              onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
              onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
            >
              <option value="">Seleccionar destino</option>
              {destinations.map(destination => (
                <option key={destination._id} value={destination.name}>
                  {destination.name}
                </option>
              ))}
            </select>
            {loadingDestinations && (
              <p style={{ fontSize: '14px', color: '#6b7280', marginTop: '5px' }}>
                Cargando destinos...
              </p>
            )}
            {!loadingDestinations && destinations.length === 0 && (
              <p style={{ fontSize: '14px', color: '#ef4444', marginTop: '5px' }}>
                No hay destinos disponibles. <Link to="/admin/destinations" style={{ color: '#3b82f6', textDecoration: 'underline' }}>Crear destino</Link>
              </p>
            )}
          </div>

          <div className="form-group">
            <label>Día de Retiro *</label>
            <input
              type="date"
              name="retreatDay"
              value={formData.retreatDay}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Dirección 1 *</label>
            <input
              type="text"
              name="direction1"
              value={formData.direction1}
              onChange={handleChange}
              placeholder="Ingresa la dirección 1"
              required
            />
          </div>

          <div className="form-group">
            <label>Horario de Bodega *</label>
            <input
              type="text"
              name="wineryHours"
              value={formData.wineryHours}
              onChange={handleChange}
              placeholder="Ej: 08:00 - 17:00"
              required
            />
          </div>

          <div className="form-group">
            <label>Dirección 2 *</label>
            <input
              type="text"
              name="direction2"
              value={formData.direction2}
              onChange={handleChange}
              placeholder="Ingresa la dirección 2"
              required
            />
          </div>

          <div className="form-group">
            <label>Horario de Almacén 2 *</label>
            <input
              type="text"
              name="warehouseSchedule2"
              value={formData.warehouseSchedule2}
              onChange={handleChange}
              placeholder="Ej: 09:00 - 18:00"
              required
            />
          </div>

          <div className="form-group">
            <label>Horario de Recogida en Almacén *</label>
            <input
              type="text"
              name="warehousePickupSchedule"
              value={formData.warehousePickupSchedule}
              onChange={handleChange}
              placeholder="Ej: 10:00 - 16:00"
              required
            />
          </div>

          <div className="form-group">
            <label>Horario de Recogida en Almacén 2 *</label>
            <input
              type="text"
              name="warehousePickupSchedule2"
              value={formData.warehousePickupSchedule2}
              onChange={handleChange}
              placeholder="Ej: 11:00 - 15:00"
              required
            />
          </div>

          <div className="form-group">
            <label>Día de Llegada al Destino - Día de Entrega *</label>
            <input
              type="date"
              name="arrivalAtDestinationDeliveryDay"
              value={formData.arrivalAtDestinationDeliveryDay}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Transporte *</label>
            <select
              name="assignedTo"
              value={formData.assignedTo}
              onChange={handleChange}
              required
            >
              <option value="">Seleccionar transporte</option>
              {users.map(user => (
                <option key={user._id} value={user._id}>
                  {user.companyName || user.name} ({user.email})
                </option>
              ))}
            </select>
            {loadingUsers && <p style={{ fontSize: '14px', color: 'var(--text-secondary)', marginTop: '5px' }}>Cargando transportes...</p>}
          </div>

          <div className="form-group">
            <label>Monto (CLP) *</label>
            <input
              type="number"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              required
              min="0"
              step="0.01"
              placeholder="Ingrese el monto"
              style={{ 
                width: '100%', 
                padding: '12px 16px', 
                border: '2px solid #e5e7eb', 
                borderRadius: '8px',
                fontSize: '14px',
                transition: 'all 0.2s',
                outline: 'none',
                backgroundColor: 'white'
              }}
              onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
              onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
            />
          </div>

          <div className="form-group">
            <label>IVA (Multiplicador, ej: 1.19) *</label>
            <input
              type="number"
              name="vat"
              value={formData.vat}
              onChange={handleChange}
              required
              min="1"
              step="0.01"
              placeholder="1.19"
              style={{ 
                width: '100%', 
                padding: '12px 16px', 
                border: '2px solid #e5e7eb', 
                borderRadius: '8px',
                fontSize: '14px',
                transition: 'all 0.2s',
                outline: 'none',
                backgroundColor: 'white'
              }}
              onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
              onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
            />
          </div>

          <div className="flex-container" style={{ marginTop: '24px' }}>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Designando...' : 'Designar Ruta'}
            </button>
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={() => navigate('/admin/routes')}
            >
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminRouteDesignate;
